import "./contact.3c53636b.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired972"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired972"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $beOXE = parcelRequire("beOXE");
var $iNA1s = parcelRequire("iNA1s");
document.addEventListener("DOMContentLoaded", function() {
    (0, $4AGbv.gsap).registerPlugin((0, $beOXE.ScrollSmoother), (0, $iNA1s.ScrollTrigger));
    let smoother = (0, $beOXE.ScrollSmoother).create({
        wrapper: "#smooth-wrapper-mywork",
        content: "#smooth-content-mywork",
        smooth: 2,
        smoothTouch: 0.1
    });
}); // const myWorkBox = document.querySelectorAll(".section-mywork__box");
 // let lastScrollY = window.scrollY;
 // window.addEventListener("scroll", function (e) {
 //   const CurrentScrollY = window.scrollY;
 //   if (CurrentScrollY > lastScrollY) {
 //     console.log("Scrolling Down");
 //     myWorkBox.forEach((box) => {
 //       box.style.transform = `skewY(-2deg)`;
 //       box.style.transition = `transform 0.5s ease`;
 //     });
 //   } else {
 //     console.log("Scrolling Up");
 //     myWorkBox.forEach((box) => {
 //       box.style.transform = `skewY(2deg)`;
 //       box.style.transition = `transform 0.5s ease`;
 //     });
 //   }
 //   lastScrollY = CurrentScrollY;
 // });
 // window.addEventListener("scrollend", function () {
 //   myWorkBox.forEach((box) => {
 //     box.style.transform = `skewY(0deg)`;
 //     box.style.transition = `transform 0.5s ease`;
 //   });
 // });


//# sourceMappingURL=mywork.736477fb.js.map
